<!--
2022-03-13 CHP 召回充值奖金弹窗(Bonus)
2022-10-24 HHY 弃用bonus，将未7天未活跃召回用户发放30%充值cash奖励
-->
<template>
  <div class="pop">
    <div class="callBackPicDiv"
         :style="{backgroundImage:'url('+require('../../assets/images/common/welcome_pop.webp')+')'}">
      <div class="cancel-btn" @click="close">
        <img style="width: 11.111vw;"
             src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTguOTk2IDQuNzEyODlDMTEuMTEzNCA0LjcxMjg5IDQuNzEyODkgMTEuMTEzMyA0LjcxMjg5IDE4Ljk5NjZDNC43MTI4OSAyNi44Nzk5IDExLjExMzQgMzMuMjgwMyAxOC45OTYgMzMuMjgwM0MyNi44ODEgMzMuMjgwMyAzMy4yNzkzIDI2Ljg3OTkgMzMuMjc5MyAxOC45OTY2QzMzLjI3OTMgMTEuMTEzMyAyNi44ODEgNC43MTI4OSAxOC45OTYgNC43MTI4OVpNMTguOTk2IDYuNjEyODlDMjUuODMxMyA2LjYxMjg5IDMxLjM3OTMgMTIuMTYxOCAzMS4zNzkzIDE4Ljk5NjZDMzEuMzc5MyAyNS44MzEzIDI1LjgzMTMgMzEuMzgwMyAxOC45OTYgMzEuMzgwM0MxMi4xNjA4IDMxLjM4MDMgNi42MTI4OSAyNS44MzEzIDYuNjEyODkgMTguOTk2NkM2LjYxMjg5IDEyLjE2MTggMTIuMTYwOCA2LjYxMjg5IDE4Ljk5NiA2LjYxMjg5WiIgZmlsbD0iI0Y2RDlBQSIgZmlsbC1vcGFjaXR5PSIwLjYiLz4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjUuNDUzMiAxMS4yMTA4TDExLjIyNDQgMjUuNDM5N0MxMC44NTM2IDI1LjgxMDUgMTAuODUzMiAyNi40MTIgMTEuMjI0NCAyNi43ODMyQzExLjU5NTUgMjcuMTU0MyAxMi4xOTcxIDI3LjE1NCAxMi41Njc5IDI2Ljc4MzJMMjYuNzk2OCAxMi41NTQzQzI3LjE2NzQgMTIuMTgzNyAyNy4xNjc5IDExLjU4MiAyNi43OTY4IDExLjIxMDhDMjYuNDI1NiAxMC44Mzk3IDI1LjgyMzkgMTAuODQwMiAyNS40NTMyIDExLjIxMDhaIiBmaWxsPSIjRjZEOUFBIiBmaWxsLW9wYWNpdHk9IjAuNiIvPg0KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNi43ODkyIDI1LjQzNDdMMTIuNTYwMyAxMS4yMDU4QzEyLjE4OTUgMTAuODM1IDExLjU4OCAxMC44MzQ3IDExLjIxNjggMTEuMjA1OEMxMC44NDU3IDExLjU3NyAxMC44NDYgMTIuMTc4NSAxMS4yMTY4IDEyLjU0OTNMMjUuNDQ1NyAyNi43NzgyQzI1LjgxNjMgMjcuMTQ4OCAyNi40MTggMjcuMTQ5MyAyNi43ODkyIDI2Ljc3ODJDMjcuMTYwMyAyNi40MDcxIDI3LjE1OTggMjUuODA1MyAyNi43ODkyIDI1LjQzNDdaIiBmaWxsPSIjRjZEOUFBIiBmaWxsLW9wYWNpdHk9IjAuNiIvPg0KPC9zdmc+DQo=">
      </div>
      <div class="deposit" @click="goToDeposit"></div>
      <div class="timer">
        <span class="hour">{{ timeLeftString.substring(0, 2) }}</span>
        <span>：</span>
        <span class="min">{{ timeLeftString.substring(3, 5) }}</span>
        <span>：</span>
        <span class="second">{{ timeLeftString.substring(6, 8) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import depositGift1 from '@/assets/images/callback/callback1.png'
import depositGift2 from '@/assets/images/callback/callback2.png'
import depositGift3 from '@/assets/images/callback/callback3.png'
import callBackTopPic from '@/assets/images/callback/callbackpictop.png'
import moreCashBtn from '@/assets/images/callback/morecashbtn.svg'
import discountMax from '@/assets/images/callback/userCallBackDiscountMax.svg'
// import request from '@/service'
import {getUTCNow, getTimeSpanString, setCurrentModal} from '@/utils'
import store from '@/store/store'

export default {
  name: 'depositCallback',
  data () {
    return {
      depositGift1,
      depositGift2,
      depositGift3,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      getTimeSpanString,
      getUTCNow,
      setCurrentModal,
      callbackTimeSpan: this.$store.state.callbackTimeSpan,
      timeLeftString: '',
      callBackTopPic,
      moreCashBtn,
      discountMax
    }
  },
  mounted () {
    if (this.userInfo) {
      setInterval(() => {
        let nowTimeSpan = (new Date()).getTime()
        let timeLeft = (this.$store.state.callbackTimeSpan - nowTimeSpan)
        if (this.$store.state.callbackTimeSpan > 0) {
          this.timeLeftString = getTimeSpanString(timeLeft)
        } else {
          // clearInterval(timer)
        }
      }, 1000)
    }
  },
  methods: {
    close: function () {
      let modals = store.state.modals
      modals[2].showing = false
      store.commit('setModals', modals)
      if (localStorage.getItem('clickCallBackIcon') === '1') {
        localStorage.setItem('clickCallBackIcon', '0')
        return
      }
      if (this.$route.name.toLocaleLowerCase() === 'home') {
        if (store.state.modals[15].popupTimes < store.state.modals[15].maxPopupTimes) {
          store.commit('setCurrentModalIndex', 15)
          setCurrentModal(15)
        } else if (store.state.modals[3].popupTimes < store.state.modals[3].maxPopupTimes) {
          store.commit('setCurrentModalIndex', 3)
          setCurrentModal(3)
        } else if (store.state.modals[5].popupTimes < store.state.modals[5].maxPopupTimes && store.state.shareFiestaShow) {
          store.commit('setCurrentModalIndex', 5) // 弹出推广狂欢
          setCurrentModal(5)
        } else if (store.state.modals[10].popupTimes < store.state.modals[10].maxPopupTimes) {
          store.commit('setCurrentModalIndex', 10) // vip弹窗
          setCurrentModal(10)
        }
      }
    },
    /****
     * 跳转到支付页面
     * 2021-07-31 C007 创建
     * */
    goToDeposit () {
      let modals = store.state.modals
      modals[2].showing = false
      store.commit('setModals', modals)
      if (this.userInfo) {
        this.$router.push({name: 'Deposit', query: {param: 'callback'}})
      } else {
        this.$router.push('/Login')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pop{
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0,0,0,.6);
  z-index: 16;
  overflow: hidden;

  .callBackPicDiv {
    position: relative;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 100vw;
    height: 117.692vw;

    .timer {
      position: absolute;
      top: 42.55vw;
      left: 50%;
      transform: translate(-50%);
      //width: 60vw;
      height: 12.5vw;
      line-height: 12.5vw;;
      font-family: Inter;
      font-size: 6.748vw;
      font-weight: 800;
      text-align: left;
      color:#ffffff;
      text-shadow: 0 0 5.5px rgba(238, 255, 40, 0.84);
      display: flex;
      align-items: center;
      gap: 1.5vw;
      .hour {
        //margin-left: 2.7vw;
        display: block;
        height: 14.2216vw;
        width: 15.004vw;
        background-color: rgba(0,0,0,0.3);
        border-radius: 2.277vw;
        text-align: center;
        line-height: 14.2216vw;
      }
      .min {
        margin-left: -3vw;
        display: block;
        height: 14.2216vw;
        width: 15.004vw;
        background-color: rgba(0,0,0,0.3);
        border-radius: 2.277vw;
        text-align: center;
        line-height: 14.2216vw;
      }
      .second {
        margin-left: -3vw;
        display: block;
        height: 14.2216vw;
        width: 15.004vw;
        background-color: rgba(0,0,0,0.3);
        border-radius: 2.277vw;
        text-align: center;
        line-height: 14.2216vw;
      }
    }
    .cancel-btn{
      position: absolute;
      top: 1vw;
      right: 6vw;
      width: 8.6vw;
      height: 8.6vw;
      img{
        width: 100%;
        height: 100%;
      }
    }

    .deposit {
      position: absolute;
      bottom: 1.8vw;
      width: 58vw;
      height: 11vw;
      left: 50%;
      transform: translate(-50%);
      border-radius: 5vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DepositCallback/bonus.vue